import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import VirtualizedThumbnail from './VirtualizedThumbnail';
import { pdfToBookPage } from '../utils/chunkUtils';

export default function PageGrid({
  totalPages,
  pageOffset,
  generateThumbnail,
  getPageChunkInfo,
  selectedPages,
  selectedChunk,
  onPageClick,
  onZoomClick,
  onCreateChunk,
  thumbnailRefs,
}) {
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <Paper elevation={2} sx={{ width: 920, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6">Pages ({totalPages})</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, mb: 2 }}>
          Book pages shown (PDF pages in parentheses)
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          fullWidth
          onClick={onCreateChunk}
          disabled={selectedPages.length === 0}
        >
          Create Chunk from Selection ({selectedPages.length})
        </Button>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 2 }}>
          {pageNumbers.map((pdfPage) => {
            const bookPage = pdfToBookPage(pdfPage, pageOffset);
            const chunkInfo = getPageChunkInfo(pdfPage);
            const isSelected = selectedPages.includes(pdfPage);
            const isInSelectedChunk =
              selectedChunk &&
              bookPage >= selectedChunk.startPage &&
              bookPage <= selectedChunk.endPage;
            return (
              <VirtualizedThumbnail
                key={pdfPage}
                pageNum={pdfPage}
                bookPageNum={bookPage}
                generateThumbnail={generateThumbnail}
                chunkInfo={chunkInfo}
                isSelected={isSelected}
                isInSelectedChunk={isInSelectedChunk}
                onPageClick={onPageClick}
                onZoomClick={onZoomClick}
                thumbnailRef={thumbnailRefs}
              />
            );
          })}
        </Box>
      </Box>
    </Paper>
  );
}
